module.exports = __webpack_public_path__ + "fonts/Muli_Regular--50aa6723c3983d2f7322ebd7fc99bdc3.50aa6723c3983d2f7322ebd7fc99bdc3.woff";